<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <Header />
    <router-view/>
  </div>
</template>
<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";

export default {
  name: 'Home',
  components: {
    Header
  },
  mounted() {
    window.addEventListener('DOMContentLoaded', function() {
      window.addEventListener('scroll', handleScroll)
    })
    function handleScroll() {
      // console.log("縦スクロール：" + window.scrollY);
      const anime = document.getElementsByClassName("anime");
      for (let index = 0; index < anime.length; index++) {
        const element = anime[index];
        const clientRect = element.getBoundingClientRect();
        const y = window.pageYOffset + clientRect.top - 300;
        if (y <= window.scrollY) {
          element.classList.add('fade-in');
        }
      }
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
